let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dJw0t")).then(() => parcelRequire('dPQzM'));